<template>
  <base-layout :menuItems="menuItems">
    <template slot="content">
      <div class="w-full h-full flex" id="groovevideoCont">
        <div
          class="overflow-y-auto w-full p-5 pt-3"
          style="max-height: calc(100vh - 3.25rem)"
        >
          <div class="container mx-auto">
            <transition :name="routerTransition">
              <router-view></router-view>
            </transition>
          </div>
        </div>
      </div>
    </template>
    <template slot="header-bar">
      <header-bar
        v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
        :routeTitle="$t(routeTitle)"
      ></header-bar>
    </template>
    <template slot="sidebar">
      <sidebar-menu></sidebar-menu>
    </template>
  </base-layout>
</template>

<script>
import BaseLayout from '../design-system/account-adapter';
import store from '@/state';

export default {
  data() {
    return {
      isExternal: true,
      showSlider: false,
      routerTransition: 'zoom-fade',
      routeTitle: this.$route.meta.pageTitle,
      isAdmin: null,
      scrollbarSettings: {
        maxScrollbarLength: 60,
      },
    };
  },

  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
  },

  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
  },
  computed: {
    menuItems() {
      return [];
    },
  },
  async created() {
    this.isAdmin = store.state.user.admin;
  },
  components: {
    BaseLayout,
  },
};
</script>

<style scoped>
#groovevideoCont {
  height: calc(100vh - 4rem) !important;
}
</style>
